import React, { useEffect, useState } from "react"

import { Row, Col } from "reactstrap"

// Pages Components
import Miniwidget from "./Miniwidget"
import MonthlyEarnings from "./montly-earnings"
import EmailSent from "./email-sent"
import MonthlyEarnings2 from "./montly-earnings2"
import Inbox from "./inbox"
import RecentActivity from "./recent-activity"
import WidgetUser from "./widget-user"
import { useSelector, useDispatch, connect } from "react-redux"
import YearlySales from "./yearly-sales"
import LatestTransactions from "./latest-transactions"
import LatestOrders from "./latest-orders"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"
// import ReviewBox from "./ReviewBox"
import SnackbarComponent from "components/SnackBar"
import axios from "axios"
import config from "config/config"
import MiniCards from "newcomponents/mini-cards"
import ReviewBox from "newcomponents/ReviewBox"

const Dashboard = props => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const userData = useSelector(state => state.Login.userData)
  const [report, setReport] = useState([])
  const [reviews, setReviews] = useState([])
  const [err, setErr] = useState(null)
  const [success, setSuccess] = useState(null)
  const mode = useSelector(state => state.Layout.layoutMode)

  document.title = "Dashboard | Reputation Management"

  const breadcrumbItems = [
    {
      title: `${activeOrganization?.name}`,
      link: "#",
    },
    { title: "Dashboard", link: "#" },
  ]

  const fetchReviews = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/yelp/getReviews?integrationIds=${
          isConsolidatedView
            ? organizations
                .map(org => org.Organization.YelpIntegrations[0].id)
                .join(",")
            : activeOrganization.YelpIntegrations[0].id
        }`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setReviews(response.data.reviews)
    } catch (err) {
      console.log(err)
      setErr("Error fetching reviews.")
    }
  }

  useEffect(() => {
    props.setBreadcrumbItems(
      `${activeOrganization?.name} (${activeOrganization?.type})`,
      breadcrumbItems,
    )

    fetchReviews()
  }, [activeOrganization, isConsolidatedView, organizations])

  useEffect(() => {
    console.log("A")
    if (reviews && reviews.length > 0) {
      console.log("B")
      let count = 0
      let sum = 0
      let latestReviewDate = null
      const positiveReviews = []
      const negativeReviews = []

      // Process Yelp reviews
      for (const review of reviews) {
        count++
        sum += parseFloat(review.rating || 0) // Ensure rating is parsed as a number

        // Find the latest review date
        const reviewDate = new Date(review.reviewDate)
        if (!latestReviewDate || reviewDate > new Date(latestReviewDate)) {
          latestReviewDate = review.reviewDate
        }

        // Categorize positive and negative reviews
        if (review.rating >= 4) {
          positiveReviews.push(review)
        } else {
          negativeReviews.push(review)
        }
      }

      const averageRating = count > 0 ? (sum / count).toFixed(1) : "N/A"

      // Build report for Miniwidget
      setReport([
        {
          title: "Total Reviews",
          iconClass: "message-draw",
          total: reviews.length,
          average: reviews.length > 10 ? "+15%" : "-5%",
          badgecolor: reviews.length > 10 ? "success" : "danger",
        },
        {
          title: "Average Rating",
          iconClass: "star",
          total: averageRating,
          average: "Stable",
          badgecolor: "warning",
        },
        {
          title: "Positive Reviews",
          iconClass: "thumb-up",
          total: positiveReviews.length,
          average: `${((positiveReviews.length / reviews.length) * 100).toFixed(1)}%`,
          badgecolor: "success",
        },
        {
          title: "Negative Reviews",
          iconClass: "thumb-down",
          total: negativeReviews.length,
          average: `${((negativeReviews.length / reviews.length) * 100).toFixed(1)}%`,
          badgecolor: "danger",
        },
      ])
    }
  }, [reviews, isConsolidatedView, organizations, activeOrganization])
  console.log("Reviews in Dashboard:", reviews)
  return (
    <React.Fragment>
      {/*mimi widgets */}
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      {/* <Miniwidget reports={report} /> */}
      <MiniCards reports={report} mode={mode} />

      <Row>
        <Col xl="6">
          {/* Monthly Earnings */}
          <MonthlyEarnings />
        </Col>

        <Col xl="6">
          {/* Email sent */}
          <EmailSent />
        </Col>

        {/* <Col xl="3"> */}
        {/* <MonthlyEarnings2 /> */}
        {/* <Inbox /> */}
        {/* </Col> */}
      </Row>
      {/* <Row>
        <Col xl={12}>
          <MonthlyEarnings2 />
        </Col>
      </Row> */}
      <Row>
        <ReviewBox reviews={reviews} mode={mode} platform="yelp" />
      </Row>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard)
